import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { SafeBackService } from 'app/core/services/safe-back.service';

/**
 * Kanban #63: same 403 copy as the shared error page, but rendered as a plain
 * flex block instead of `absolute inset-0` — meant to be mounted as a child
 * of `adminShellRoutes` (inside `LayoutComponent`) so a role-guard rejection
 * on an already-authenticated route keeps the nav/topbar instead of dropping
 * the user onto the bare, shell-less `/errors/forbidden` page.
 * `RouteDataAuthorizationGuard` redirects here (`/forbidden`) instead.
 */
@Component({
    selector: 'app-in-shell-forbidden',
    standalone: true,
    imports: [RouterModule, TranslocoModule],
    templateUrl: './in-shell-forbidden.component.html',
})
export class InShellForbiddenComponent {
    private readonly _safeBack = inject(SafeBackService);

    goBack(): void {
        this._safeBack.goBack();
    }
}
